import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import axios from "axios"

import Header from "./components/common/Header/Header"
import Footer from "./components/common/Footer/Footer"

import ScrollToTop from "./components/global/ScrollToTop/ScrollToTop";

import HomeScreen from "./screens/HomeScreen";
import MembersScreen from "./screens/MembersScreen";
import InitiativesScreen from "./screens/InitiativesScreen";
import InitiativesDetailScreen from "./screens/InitiativesDetailScreen";
import InternationalScreen from "./screens/InternationalScreen";
import DocumentsScreen from "./screens/DocumentsScreen";
import ContactScreen from "./screens/ContactScreen";
import FundracingScreen from "./screens/FundracingScreen";
import RadjeScreen from "./screens/RadjeScreen";
import ANBIScreen from "./screens/ANBIScreen";
import NotFoundScreen from "./screens/NotFoundScreen";

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: '',
      loading: false,
      primaryMenuData: [],
      hamburgerMenuData: [],
    }
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = () => {
    this.setState({loading: true})
    axios.all([
      axios.get(`/wp-json/wp-api-menus/v2/menus/12`),
      axios.get(`/wp-json/wp-api-menus/v2/menus/13`)
    ])
    .then(axios.spread((resPrimaryMenuData, resHamburgerMenuData) => {
      this.setState({ primaryMenuData: resPrimaryMenuData.data})
      this.setState({ hamburgerMenuData: resHamburgerMenuData.data})
      this.setState({ loading: false })
    }))
    .catch(error => {
      console.log(error);
    })
  }

  render() {

    return (
      <Router>
        <ScrollToTop />
        <div>

          <Header primary={this.state.primaryMenuData} hamburger={this.state.hamburgerMenuData} />

          <Switch>
            <Route exact path="/" component={HomeScreen} />
            <Route exact path="/leden" render={(props) => ( <MembersScreen {...props}/> )} />
            <Route exact path="/initiatieven" component={InitiativesScreen}/>
            <Route exact path="/initiatieven/:initiatief_slug" render={(props) => ( <InitiativesDetailScreen {...props}/> )} />
            <Route exact path="/internationaal" component={InternationalScreen} />
            <Route exact path="/documenten" component={DocumentsScreen} />
            <Route exact path="/radjevoordesfeer" component={RadjeScreen} />
            <Route path="/contact" component={ContactScreen} />
            <Route path="/fundracing" component={FundracingScreen} />
            {/* <Route path="/anbi-status-van-rt132" component={ANBIScreen} /> */}
            <Route component = { NotFoundScreen } />
          </Switch>

          <Footer/>

        </div>
      </Router>
    );
  }
}

export default App;
